//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import lockMX from './mixins/lockMX.js'

  export default {
    name: 'depositList',
    mixins: [lockMX],
    data() {
      return {
        status: [ // 锁定状态
          { name: '全部状态',value: '', langKey: 'all' },
          { name: '锁定中',value: '0', langKey: 'lock' },
          { name: '已解锁',value: '1', langKey: 'unlock' }
        ],

        depositList: [],
        lockStatus: [''],
      }
    },
    created() {
      this.depositQueryUserLockAmount()
    },
    methods: {
      closeSearch(type) { // 关闭条件选择
        this._setConditionName(type)
        this.pageNo = 1;
        this.isShowDialog = false;
        if (this.$refs.loadMoreEle) this.$refs.loadMoreEle.scrollToTop()
        this.depositQueryUserLockAmount();
      },

      _getParams() { // 获取请求参数
        return {
          UUID: this.UUID,
          lockType: 'deposit',
          startTime: '',
          platformCode: '',
          status: this.lockStatus[0],
          type: '',
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
      }
    }
  }



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/LockAmount/depositList.vue